export const logColumns = [{
  title: 'Error Name',
  dataKey: 'name',
  key: 'name',
  width: 350,
  sortable: true,
  resizable: true,
},
{
  title: 'Updated on',
  dataKey: 'updatedAt',
  key: 'updatedAt',
  width: 200,
  sortable: true,
  resizable: true,
},
{
  title: 'Rule',
  dataKey: 'rules',
  key: 'rules',
  width: 450,
  sortable: true,
  resizable: true,
},
{
  title: 'Updated By',
  dataKey: 'updatedBy.email',
  key: 'updatedBy.email',
  width: 200,
  sortable: true,
  resizable: true,
},
{
  title: 'Status',
  dataKey: 'state',
  key: 'state',
  width: 100,
  sortable: true,
  resizable: true,
}];
